<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            navigationPath="StudentView"
            navigationField="studentID"
            :selectionEnabled="true"
        ></dx-grid>

        <v-dialog v-model="updateBusDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2">Update Bus</v-card-title>
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; height: 300px">
                        <div v-for="(student, index) in selected">
                            <div class="font-weight-medium">
                                {{
                                    student.hebName +
                                        " " +
                                        student.lastNameH +
                                        " (" +
                                        student.branch +
                                        " | " +
                                        student.class +
                                        ")"
                                }}
                            </div>
                            <div class="caption">
                                Father: {{ student.hname }}
                            </div>
                            <div class="caption">
                                {{ student.busAddress1 }}
                            </div>
                            <div class="body-2">
                                {{ student.homePhone }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>
                    <!-- <v-select
                        v-model="bus"
                        label="Bus"
                        outline
                        class="mb-2 mt-2"
                        :rules="[rules.required]"
                        ref="bus"
                        :items="buses.map((b) => b.busDescribtion)"
                    ></v-select> -->
                    <v-autocomplete
                        class="mb-3 mt-2"
                        hide-details
                        label="Bus"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="bus"
                        outline
                        v-model="bus"
                        :items="busesBulk.map((b) => b.busDescribtion)"
                        :search-input.sync="loadBusesSearchBulk"
                        clearable
                    ></v-autocomplete>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateBusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveBusInBulk"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Student</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium">
                            {{
                                clickedRow.hebName +
                                    " " +
                                    clickedRow.lastNameH +
                                    " (" +
                                    clickedRow.branch +
                                    " | " +
                                    clickedRow.class +
                                    ")"
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div>{{ clickedRow.hname }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{ clickedRow.busAddress1 }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Primary Phone
                        </div>
                        <div>{{ clickedRow.homePhone }}</div>
                    </v-layout>
                    <!-- <v-select
                        v-model="clickedRow.bus"
                        label="Bus"
                        outline
                        class="mb-0 mt-3"
                        :rules="[rules.required]"
                        ref="selectedBus"
                        :items="buses.map((b) => b.busDescribtion)"
                    ></v-select> -->

                    <v-autocomplete
                        class="mb-4 mt-3"
                        hide-details
                        outline
                        label="Bus"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="selectedBus"
                        v-model="clickedRow.bus"
                        :rules="[rules.required]"
                        :items="buses.map((b) => b.busDescribtion)"
                        :search-input.sync="loadBusesSearch"
                        clearable
                    ></v-autocomplete>
                </div>
                <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveBus()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        updateBusDialog: false,
        processing: false,
        bus: "",
        selected: [],
        busesAll: [],
        buses: [],
        busesBulk: [],
        loadBusesSearch: null,
        loadBusesSearchBulk: null,
        updateDialog: false,
        clickedRow: {},

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                label: "Provider",
                field: "provider",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "engName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name H",
                field: "lastNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name H",
                field: "hebName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                link: "StudentView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher 2",
                field: "teacherH2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Address",
                field: "busAddress1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Code",
                field: "busCode",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Bus House",
                field: "busHouse",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Street",
                field: "busStreet",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "Pending Bus Code",
                field: "pendingBusCode",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Pending Bus Change",
                field: "hasPendingBusChange",
                format: "",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Changed At",
                field: "busChangedAt",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Special Needs Program",
            //     field: "specialNeedsProgram",
            //     format: "",
            //     visible: true,
            //     type: "boolean",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
        ],
    }),
    watch: {
        loadBusesSearch(value) {
            if (!value) {
                this.loadBuses();

                return;
            }

            if (!this.busesAll.length) return;

            this.buses = this.busesAll.filter((b) =>
                b.busDescribtion.toUpperCase().startsWith(value.toUpperCase()),
            );
        },
        loadBusesSearchBulk(value) {
            if (!value) {
                this.loadBuses();

                return;
            }

            if (!this.busesAll.length) return;

            this.busesBulk = this.busesAll.filter((b) =>
                b.busDescribtion.toUpperCase().startsWith(value.toUpperCase()),
            );
        },
    },
    async created() {
        this.columns.find(
            (c) => c.field == "familyID",
        ).showLink = this.showLink;

        this.columns.find((c) => c.field == "busCode").linkAction = (row) => {
            this.openUpdateDialog(row);
        };

        this.loadBuses();
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            this.actions.push({
                text: "Update Bus",
                action: this.openUpdateBus,
                showOnSelection: true,
            });

            let url =
                "allStudents?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = url += "&grade=&section=&regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        async loadBuses() {
            this.busesAll = await this.$http.get("api/Students/GetBuses");
            this.buses = this.busesAll;
            this.busesBulk = this.busesAll;
        },
        onTermSelected(value) {
            this.regID = value;

            let url =
                "allStudents?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            this.url = url += "&grade=&section=&regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        openUpdateDialog(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            if (this.clickedRow.busCode) {
                const bus = this.buses.find(
                    (b) => b.busCode == this.clickedRow.busCode,
                );

                this.clickedRow.bus = bus ? bus.busDescribtion : "";
            }

            this.updateDialog = true;

            this.$refs.selectedBus.resetValidation(true);
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        openUpdateBus() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.updateBusDialog = true;
        },
        async saveBus() {
            if (!this.$refs.selectedBus.validate(true)) return;

            const busCode = this.buses.find(
                (b) => b.busDescribtion == this.clickedRow.bus,
            ).busCode;

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/students/saveBusChange",
                    [
                        {
                            studentID: this.clickedRow.studentID,
                            accountID: this.clickedRow.familyID,
                            busCode: busCode,
                            Username: this.$store.state.authentication.user,
                            date: moment().format("YYYY-MM-DD HH:mm:ss"),
                        },
                    ],
                );

                this.processing = false;
                this.updateDialog = false;
                this.clickedRow.bus = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveBusInBulk() {
            if (!this.selected.length) {
                return this.$notify({
                    text: "No Students Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.bus.validate(true)) return;

            const busCode = this.busesAll.find(
                (b) => b.busDescribtion == this.bus,
            ).busCode;

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/students/saveBusChange",
                    this.selected.map((student) => ({
                        studentID: student.studentID,
                        accountID: student.familyID,
                        busCode: busCode,
                        Username: this.$store.state.authentication.user,
                        date: moment().format("YYYY-MM-DD HH:mm:ss"),
                    })),
                );

                this.processing = false;
                this.updateBusDialog = false;
                this.bus = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
